import { Directive, Input } from '@angular/core';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';
import { HrTableDirective } from './hr-table.directive';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HvlPage } from '@hvlng/framework-bff/core';

@Directive({
    standalone: true,
    selector: '[hrLazyTable]',
})
export class HrLazyTableDirective extends HrTableDirective<HvlPage<any>>{

    constructor(primeNgTable: Table) {
        super(primeNgTable);
        primeNgTable.lazy = true;
        this.listData$.pipe(takeUntilDestroyed()).subscribe(page =>{
            primeNgTable.totalRecords = page?.totalElements ?? 0;
            primeNgTable.value = page?.data;
        })
    }

}
